var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('v-header',{attrs:{"title":"消息中心"}}),_vm._v(" "),_c('el-container',{attrs:{"id":"Msg"}},[_c('el-aside',[_c('v-sidebar',{class:{'sidebar' : _vm.isShow,'hideSidebar':_vm.isHide}})],1),_vm._v(" "),_c('el-main',{staticClass:"msgRight"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e417ca32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MsgHome.vue
// module id = null
// module chunks = 